import { hasElements, NO_ELEMENT } from 'utils';
import { EditorialsSection } from 'components/Editorials/editorials';
import { getEditorials } from '../selectors';
import styles from './editorialArticles.scss';
import { Message } from './message';
import { EditorialPaging } from './editorialPaging';
import { useSelector } from 'react-redux';
import { useRef } from 'react';

export const EditorialArticles = () => {
  const editorials = useSelector(getEditorials);
  const anchorRef = useRef(NO_ELEMENT);

  if (!hasElements(editorials)) {
    return <Message />;
  }

  return (
    <>
      <a ref={anchorRef} />
      <EditorialsSection editorials={editorials} sectionClassName={styles.articlesSection}>
        <EditorialPaging anchorRef={anchorRef} />
      </EditorialsSection>
    </>
  );
};
